"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatch_onPageTitleChanged = void 0;
const thunder_dispatcher_1 = require("./thunder-dispatcher");
exports.dispatch_onPageTitleChanged = new thunder_dispatcher_1.ThunderDispatcher('__onPageTitleChanged');
